import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';

export default () => {
	domContentLoaded(() => {
		const $button = $('.js-fixbutton');
		$(window).on('load', () => {
			$button.addClass('is-active');
		});
	});
};
